<template>
  <section data-cy="call-to-action">
    <p class="call-to-action">{{ message }}</p>
  </section>
</template>

<script>
export default {
  name: 'CTA',
  props: {
    message: { type: String, default: '' },
  },
};
</script>

<style lang="postcss" scoped>
.call-to-action {
  padding: var(--space-8);
  color: var(--grey);
  font-size: var(--font-size-14);
  font-weight: 400;
  letter-spacing: 0;
  line-height: 18px;
  min-height: 18px;
  text-align: center;
}
</style>
